// data fetched from the api
interface Track {
    id: string;
    title: string;
    visibility: boolean;
    install: boolean;
    // download size in bytes, from the catalogue
    volumeByteSize?: number | string;
    audioByteSize?: number | string;
}

interface ReturnTrack {
    id: string;
    visibility: boolean;
    install: boolean;
}

// a series is provisioned as a whole: install and visibility are set once on
// the series and apply to every track in it
interface Series {
    id: string;
    title: string;
    visibility: boolean;
    install: boolean;
    tracks?: Track[];
}

interface ReturnSeries {
    id: string;
    visibility: boolean;
    install: boolean;
}

interface Artist {
    id: string;
    name: string;
    tracks: Track[];
    series?: Series[];
}

// data to be sent back to the api
interface ReturnArtist {
    id: string;
    tracks: ReturnTrack[];
    series: ReturnSeries[];
}

// per institution app settings, set from the dashboard
interface Settings {
    // whether the settings menu is available in the app on the headsets
    settingsAvailable: boolean;
    // date (YYYY-MM-DD) from which the app stops showing content on the headsets, empty for none
    disableDate?: string;
}

interface Content {
    artists: Artist[];
    settings?: Settings;
}

interface Data {
    content: Content;
}

interface ReturnData {
    artists: ReturnArtist[];
    settings: Settings;
}

// device status fetched from the api

interface DeviceTrack {
    name: string;
    installed: boolean;
    install: boolean;
    status: string;
    id: string;
}

interface DeviceArtist {
    tracks: DeviceTrack[];
    id: string;
    name: string;
}

export const DeviceState = {
    COMPLETE: "Complete",
    PENDING: "Incomplete",
    ERROR: "Error",
};

interface Device {
    name: string;
    id: string;
    artists: DeviceArtist[];
    last_updated_utc?: string;
    status: DeviceState;
    // storage on the headset in MB, as last reported by the app. Missing or
    // negative when the headset has not reported it.
    freeSpaceMB?: number;
    totalSpaceMB?: number;
}

type DevicesResponse = Device[];

export type { Content, Settings, Data, ReturnData, Series, ReturnSeries, Artist, ReturnArtist, Track, ReturnTrack, DeviceTrack, DeviceArtist, Device, DevicesResponse }
export type DeviceState = typeof DeviceState[keyof typeof DeviceState]; // eslint-disable-line

